import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43207ed5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fw-700 side-heading" }
const _hoisted_2 = { class: "small text-muted mb-1" }
const _hoisted_3 = {
  key: 1,
  class: "row align-items-end"
}
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = { class: "col-2" }
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = { class: "small text-muted mb-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_ColorSolidEditor = _resolveComponent("ColorSolidEditor")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      (_ctx.compact)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.label), 1),
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.localDto.style_code,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localDto.style_code) = $event)),
                _ctx.emitModelChanged
              ],
              options: _ctx.enumStyleCode,
              name: `${_ctx.name} ${_ctx.$t('style')}`,
              label: _ctx.$t('style'),
              selectText: _ctx.$t('selectText'),
              errors: _ctx.errors,
              canClear: true,
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "disabled", "onUpdate:modelValue"]),
            _createVNode(_component_InputNumber, {
              modelValue: _ctx.localDto.width_in_px,
              "onUpdate:modelValue": [
                _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localDto.width_in_px) = $event)),
                _ctx.emitModelChanged
              ],
              name: `${_ctx.name} ${_ctx.$t('width')}`,
              label: _ctx.$t('width'),
              mode: "group-end",
              "addon-text": "px",
              min: 0,
              errors: _ctx.errors,
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "name", "label", "errors", "disabled", "onUpdate:modelValue"]),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('color')), 1),
            _createVNode(_component_ColorSolidEditor, {
              modelValue: _ctx.localDto.color,
              "onUpdate:modelValue": [
                _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localDto.color) = $event)),
                _ctx.emitModelChanged
              ],
              name: _ctx.name,
              errors: _ctx.errors,
              isBackground: true,
              disabled: _ctx.disabled,
              "full-width": ""
            }, null, 8, ["modelValue", "name", "errors", "disabled", "onUpdate:modelValue"])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.localDto.style_code,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localDto.style_code) = $event)),
                  _ctx.emitModelChanged
                ],
                options: _ctx.enumStyleCode,
                name: `${_ctx.name} ${_ctx.$t('style')}`,
                label: _ctx.$t('style'),
                selectText: _ctx.$t('selectText'),
                errors: _ctx.errors,
                canClear: true,
                disabled: _ctx.disabled
              }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "disabled", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_InputNumber, {
                modelValue: _ctx.localDto.width_in_px,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localDto.width_in_px) = $event)),
                  _ctx.emitModelChanged
                ],
                name: `${_ctx.name} ${_ctx.$t('width')}`,
                label: _ctx.$t('width'),
                mode: "group-end",
                "addon-text": "px",
                min: 0,
                errors: _ctx.errors,
                disabled: _ctx.disabled
              }, null, 8, ["modelValue", "name", "label", "errors", "disabled", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('color')), 1),
              _createVNode(_component_ColorSolidEditor, {
                modelValue: _ctx.localDto.color,
                "onUpdate:modelValue": [
                  _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localDto.color) = $event)),
                  _ctx.emitModelChanged
                ],
                name: _ctx.name,
                errors: _ctx.errors,
                isBackground: true,
                disabled: _ctx.disabled,
                "full-width": ""
              }, null, 8, ["modelValue", "name", "errors", "disabled", "onUpdate:modelValue"])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["componentUI"]))
}